var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatLicensePdp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#84BD00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.547 20.5L32.8301 22.2169L24.7017 30.3453L22.529 28.4309L20.7058 26.8357L17.5 30.4972L19.3384 32.0926L23.2279 35.4959L24.9296 37L26.5401 35.3895L36.2638 25.6658L37.9807 23.9489L34.547 20.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatLicensePdp);
export default __webpack_public_path__ + "static/media/seat-license-pdp.30b8a06dec4cf910cee357a69c3b07d9.svg";
export { ForwardRef as ReactComponent };